import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/workflows/global-workflows']['GET'];

const getGlobalWorkflows = async (): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/workflows/global-workflows`);
  return response.data;
};

export default getGlobalWorkflows;